import React, { useLayoutEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const StackedColumnChart = ({ data }: any) => {
  useLayoutEffect(() => {
    let root = am5.Root.new("chartdiv");

    /* remove amchart logo */
    root._logo?.dispose();

    // Set themes
    root.setThemes([am5themes_Animated.new(root)]);

    // Create chart
    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "panX",
        wheelY: "zoomX",
        layout: root.verticalLayout,
      })
    );
    chart.children.unshift(
      am5.Label.new(root, {
        text: "Win-Loss by SBU FY-YTD",
        fontWeight: "600",
        textAlign: "center",
        x: am5.percent(50),
        centerX: am5.percent(100),
      })
    );

    let xRenderer = am5xy.AxisRendererX.new(root, {
      cellStartLocation: 0.1,
      cellEndLocation: 0.9,
      minGridDistance: 70,
    });
    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "category",
        renderer: xRenderer,
        maxWidth: 1000,
        tooltip: am5.Tooltip.new(root, {}),
      })
    );

    xRenderer.grid.template.setAll({
      location: 1,
    });

    xAxis.labelsContainer.set(
      "tooltip",
      am5.Tooltip.new(root, {
        pointerOrientation: "up",
      })
    );
    xAxis.get("renderer").labels.template.setAll({
      oversizedBehavior: "truncate",
      maxWidth: 80,
      textAlign: "center",
      tooltipText: "{category}",
    });

    xRenderer.labels.template.setup = function (target: any) {
      target.set(
        "background",
        am5.Rectangle.new(root, {
          fill: am5.color(0x000000),
          fillOpacity: 0,
        })
      );
    };

    xAxis.data.setAll(data);

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        numberFormat: "#.a",
        min: 0,
        renderer: am5xy.AxisRendererY.new(root, {
          strokeOpacity: 0.1,
        }),
      })
    );

    // Add series
    function makeSeries(name: string, fieldName: string) {
      let series = chart.series.push(
        am5xy.ColumnSeries.new(root, {
          name: name,
          stacked: true,
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: fieldName,
          // valueYShow: "valueYTotalPercent",
          categoryXField: "category",
        })
      );

      series.columns.template.setAll({
        tooltipText: `{name}, #: {${fieldName}Count}, INR {valueY} Cr `,
        tooltipY: am5.percent(10),
        width: am5.percent(40),
      });
      series.data.setAll(data);

      series.appear();

      series.bullets.push(function () {
        return am5.Bullet.new(root, {
          sprite: am5.Label.new(root, {
            fill: root.interfaceColors.get("alternativeText"),
            centerY: am5.p50,
            centerX: am5.p50,
            populateText: true,
          }),
        });
      });

      // legend.data.push(series);
    }

    makeSeries("Won", "won");
    makeSeries("Lost", "lost");

    chart.appear(1000, 100);

    return () => {
      // Clean up any resources or event listeners here
      root.dispose();
    };
  }, [data]);
  return <div id="chartdiv" style={{ width: "100%", height: "100%" }}></div>;
};

export default StackedColumnChart;
